import { render, staticRenderFns } from "./manageItem.vue?vue&type=template&id=404cd326"
import script from "./manageItem.vue?vue&type=script&lang=js"
export * from "./manageItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports